import _ from "lodash";
import { BRANDS_DATA } from "constants/action-types";
import { defaultCheckError, progressEpic } from "epics/base-epic";
import { buildFetchParams } from "helpers/epics";
import { IBrandData, IBrandsDataStatePayload } from "reducers/brands-data-reducers";
import { IFetchBrandsDataActionPayload } from "actions/brands-data-actions";

export const brandListEpic = progressEpic<IFetchBrandsDataActionPayload, IBrandsDataStatePayload>(
    BRANDS_DATA.FETCH,
    buildFetchParams("GET"),
    {
        checkErrorStatus: defaultCheckError,
        dataCustomizer: (brandsData: IBrandData[]) => ({ brandsDataById: _.keyBy(brandsData, "_id") }),
    }
);
